const isPageLoaded = state => page => state[`${page}-loaded`];
const isPageLoading = state => page => state[`${page}-loading`];

export default {
  isPageLoaded,
  isPageLoading
};
